// Android's WebView file chooser can hand over a GIF with an empty or generic
// MIME type, so check the file header ("GIF87a" / "GIF89a") instead of trusting
// file.type alone.
export default async function isGifFile(file: Blob) {
    if (file.type === 'image/gif') return true
    const header = new Uint8Array(await file.slice(0, 4).arrayBuffer())
    return String.fromCharCode(...header) === 'GIF8'
}
